// @flow
import React from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import { withTheme } from '@material-ui/core/styles';

import CloseIcon from '@material-ui/icons/Close';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import IconButton from '@material-ui/core/IconButton';

import SnackbarContent from '@material-ui/core/SnackbarContent';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

type Props = {
  message: string,
  message: Object,
  onClose: Function,
  theme: Object,
  variant: string,
};

const styles1 = theme => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

const Toaster = ({ message, onClose, variant, theme }: Props) => {
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      css={{ backgroundColor: styles1(theme)[variant].backgroundColor }}
      aria-describedby="client-snackbar"
      message={
        <span
          id="client-snackbar"
          css={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Icon />
          {message}
        </span>
      }
      action={[
        <IconButton key="close" aria-label="Close" color="inherit" onClick={onClose}>
          <CloseIcon />
        </IconButton>,
      ]}
    />
  );
};

export const ToasterComponent = withTheme(Toaster);
